import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';

const RouteContainer = ({ isProtected = false, roles = [], ...props }) => {
  const isAutenticated = useSelector((state) => state.auth.isAutenticated);
  const isAutenticating = useSelector((state) => state.auth.isAutenticating);
  const transmissionActivity = useSelector(
    (state) => state.subscription.transmissionActivity
  );
  const isOnlyStreaming = useSelector((state) => state.streaming.isOnlyStreaming);
  const centerCostId = useSelector((state) => state.auth.cc);

  if (isProtected && isAutenticating) {
    return <div>loading</div>;
  }

  if (isProtected && !isAutenticating && !isAutenticated) {
    let to = '/';
    if (isOnlyStreaming && centerCostId && transmissionActivity?.aga_id) {
      to = `login/${centerCostId}?onlyStreaming=true&streaming_aga_id=${transmissionActivity?.aga_id}`;
    }
    if (['ead', 'detail-ead'].includes(window.location.pathname.split('/')[1])) {
      to = '/ead';
    }
    return <Redirect to={to} />
  }

  return <Route {...props} />;
};

export default RouteContainer;
